import React from 'react';

export interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'primary' | 'success' | 'warning' | 'error';
  size?: 'sm' | 'md';
  className?: string;
}

/**
 * Badge component for displaying labels and tags
 *
 * Variants:
 * - default: Gray badge
 * - primary: Indigo badge
 * - success: Green badge
 * - warning: Amber badge
 * - error: Red badge
 */
export const Badge: React.FC<BadgeProps> = ({ children, variant = 'default', size = 'md', className }) => {
  const variantClasses = {
    default: 'bg-gray-200 text-gray-900 dark:bg-gray-700 dark:text-gray-100',
    primary: 'bg-indigo-100 text-indigo-900 dark:bg-indigo-900 dark:text-indigo-100',
    success: 'bg-emerald-100 text-emerald-900 dark:bg-emerald-900 dark:text-emerald-100',
    warning: 'bg-amber-100 text-amber-900 dark:bg-amber-900 dark:text-amber-100',
    error: 'bg-red-100 text-red-900 dark:bg-red-900 dark:text-red-100',
  };

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs font-medium rounded',
    md: 'px-2.5 py-0.5 text-sm font-medium rounded-md',
  };

  return (
    <span className={`inline-flex items-center ${variantClasses[variant]} ${sizeClasses[size]} ${className || ''}`}>
      {children}
    </span>
  );
};
